import type { SetStats } from '@/domain/selectors';
import { useT } from '@/i18n/useT';
import { ProgressBar } from '@/components/ui/ProgressBar';

interface StatsBarProps {
  stats: SetStats;
}

export function StatsBar({ stats }: StatsBarProps) {
  const { t } = useT();
  const remaining = stats.total - stats.done;

  return (
    <div className="flex items-center gap-3 border-b border-line bg-surface/80 px-2 py-1.5 backdrop-blur">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <span className="tnum shrink-0 text-[13px] leading-5 font-semibold text-pip">
          {t('stats.collected', { done: stats.done, total: stats.total })}
        </span>
        <span className="tnum shrink-0 text-[11px] leading-4 text-text-faint">
          {t('stats.percent', { percent: stats.percent })}
        </span>
        <div className="min-w-16 flex-1">
          <ProgressBar
            done={stats.done}
            total={stats.total}
            label={t('stats.progressAria', { done: stats.done, total: stats.total })}
          />
        </div>
        <span className="tnum shrink-0 text-[11px] leading-4 text-text-dim" aria-live="polite">
          {remaining === 0 ? t('stats.allDone') : t('stats.remaining', { n: remaining })}
        </span>
      </div>
    </div>
  );
}
